<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title primary-title> Reactivate Device </v-card-title>
      <v-card-text>
        <div>Really reactivate this device?</div>

        <div>DeviceId: {{ device_info.unique_id }}</div>
      </v-card-text>
      <v-card-actions>
        <v-progress-circular
          v-show="loading"
          :value="20"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <v-spacer></v-spacer>
        <v-btn v-show="!loading" color="gray" rounded outlined @click="dialog = false"
          >Cancel</v-btn
        >
        <v-btn v-show="!loading" color="primary" rounded @click="reactivate()">Reactivate</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialog: false,
      status: '',
      device_info: [],
    };
  },

  methods: {
    open(device_info) {
      this.device_info = device_info;
      this.status = '';
      this.dialog = true;
    },

    async reactivate() {
      this.loading = true;
      this.status = 'Loading...';

      try {
        await axios.post(`/admin/users/devices/reactivate/${this.device_info.unique_id}`);
        this.$emit('reactivated', this.device_info.unique_id);
        this.dialog = false;
      } catch (e) {
        this.status = 'Error while reactivating device.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
